import {Box, Button, Snackbar, Stack} from "@mui/material";
import SearchInput from "../../components/SearchInput";
import LoadingScreen from "../../components/LoadingScreen";
import CustomTable from "../../components/TableColumnShapes/CustomTable";
import {Alert} from "@mui/lab";
import React, {FC, useEffect, useState} from "react";
import StyledFlexBox from "../../components/StyledFlexBox";
import {ColumnActionProps} from "../../types/ColumnActionProps";
import useTitle from "../../hooks/useTitle";
import RegisterDriverDialog from "./RegisterDriverDialog";
import DriverListColumnShape from "../../components/TableColumnShapes/DriverListColumnShape";
import {DriverFormData, IDriver} from "../../types/Driver";
import {getDrivers} from "../../api/user";
import StyledPagination from "../../components/StyledPagination";
import updateQueryParams from "../../utils/updateQueryParams";
import {useSearchParams} from "react-router-dom";
import DriverDetailsDialog from "./DriverDetailsDialog";

const DriversPage: FC = () => {
    useTitle("Conducteurs")
    const searchParams = useSearchParams()[0]
    const [drivers, setDrivers] = useState<DriverFormData[]>([])
    const [dataCount, setDataCount] = useState<number>(0)
    const [action, setAction] = useState<"create" | "update">()
    const [currentItem, setCurrentItem] = useState<IDriver>({})
    const [createFormOpen, setCreateFormOpen] = useState(false)
    const [showDetailsDialog, setShowDetailsDialog] = useState(false)
    const [showActionResultFeedback, setShowActionResultFeedback] = useState(false)
    const [loadingData, setLoadingData] = useState(false)
    const [actionResult, setActionResult] = useState<{ status: "success" | "error", message?: string }>()
    const loadData = () => {
        setLoadingData(true)
        getDrivers(parseInt(searchParams.get("page") || "1"))
            .then(value => {
                setLoadingData(false)
                setDrivers(value.data)
                setDataCount(value.count)
            }).catch(() => {
            setLoadingData(false)
        })
    }
    const columnActionProps: ColumnActionProps<DriverFormData> = {
        onViewDetailsAction: (item) => {
            setCurrentItem(item)
            setShowDetailsDialog(true)
        },
    }
    const handleCreateRole = () => {
        setAction("create")
        setCreateFormOpen(true)
    }

    const handleSnackbarClose = () => {
        setShowActionResultFeedback(false)
    }


    useEffect(() => {
        loadData()
    }, [])

    return (<Box pt={2} pb={4}>
            <StyledFlexBox>
                <SearchInput placeholder="Rechercher un conducteur..."/>
                <Button variant="contained" onClick={handleCreateRole}>
                    Enregistrer un Conducteur
                </Button>
            </StyledFlexBox>

            {loadingData ? <LoadingScreen/> :
                <Stack width={"100%"} gap={1} alignItems={"center"}>
                    <CustomTable columnShape={DriverListColumnShape(columnActionProps)} data={drivers}/>
                    <StyledPagination variant={"outlined"} page={parseInt(searchParams.get("page")) || 1}
                                      count={Math.ceil(dataCount / 15)}
                                      onChange={(event, p) => updateQueryParams("page", [p.toString()])}
                                      size={"large"}/>
                </Stack>}

            {createFormOpen &&
                <RegisterDriverDialog initialData={currentItem}
                                      action={action}
                                      onCreateEntityStatusChange={(status, message) => {
                                          if (status === "success")
                                              loadData()

                                          setActionResult({
                                              status,
                                              message
                                          })
                                          setShowActionResultFeedback(true)
                                      }}
                                      onClose={() => {
                                          setCurrentItem(null)
                                          setCreateFormOpen(false)
                                      }}
                                      open={true}/>}

            {showDetailsDialog && <DriverDetailsDialog driver={currentItem} open={true}
                                                       onClose={() => setShowDetailsDialog(false)}/>}


            <Snackbar open={showActionResultFeedback} autoHideDuration={6000} onClose={handleSnackbarClose}>
                <Alert
                    onClose={handleSnackbarClose}
                    severity={actionResult?.status}
                    variant="outlined"
                    sx={{width: '100%'}}>
                    {actionResult?.message || "Conducteur enregistré avec succès"}
                </Alert>
            </Snackbar>

        </Box>
    )

}

export default DriversPage